// openLiveStreamKaraokeModal.js
'use strict';

import addModal from '../action/addModal.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
/**
 * Open live stream karaoke modal
 * @kind action
 * @return {Promise} Action promise.
 */
const openLiveStreamKaraokeModal = () => async dispatch => {
  dispatch({
    type: MERGE_OPERATION_DATA,
    payload: {
      selectPath: ['liveStream'],
      data: {
        shouldDisplayKaraokeTooltip: false,
      },
    },
  });
  return dispatch(
    addModal({
      id: 'LiveStreamKaraokeModal',
      isHigherThanAll: true,
      transitionStatus: 'coming',
    })
  );
};

export default openLiveStreamKaraokeModal;
